'use client';

import PageUnavailable from '@/components/default/views/page/components/PageUnavailable';

export default function SlugPageError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
    return <PageUnavailable variant="error" onRetry={reset} />;
}
